import PlatformService from "@/services/Platform";

const FeatureService = {
  /**
   * This is a huge driver of a lot of other features, whether users can use the web app
   */
  customersCanUseWebApp() {
    return false;
  },

  /**
   * Do we allow users to sign up
   */
  canSignUp() {
    return this.customersCanUseWebApp() || PlatformService.isMobile();
  },

  /**
   * Staff always can, but can the customer?
   */
  canCustomerSignIn() {
    return this.customersCanUseWebApp() || PlatformService.isMobile();
  },

  /**
   * This is when we know that we'd like them to get the mobile app instead.
   */
  shouldEncourageToGetMobileApp() {
    return PlatformService.isWeb();
  },

  /**
   * The app gives an intro if its your first time
   */
  shouldShowAppIntroScreen() {
    return true;
  },

  /**
   * Whether we attempt to use GPS
   *
   * @todo get this working in test, right now it's off for e2e tests
   */
  hasGPSAccess() {
    return !window.Cypress;
  }
};

export default FeatureService;
